// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.event-info{
  width: 30%;
  float: left;
  margin-right: 1%;
  min-height: 200px;
  margin-top: 50px;
  cursor: pointer;
}
.event-info div{
  font-size: 24px;
}

@media (max-width: 768px){
  .event-info{
    width: 45%;
    min-height: 140px;
    margin-top: 0px;
    margin-bottom: 15px;
    cursor: pointer;
}
}

@media (max-width: 576px){
  .event-info{
    width: 100%;
    min-height: 80px;
    margin-top: 0px;
    margin-bottom: 10px;
    cursor: pointer;
}
}

.mat-card-title{
  margin-left:-16px;
}

.message{
  margin-bottom: 10px;
  margin-left: -15px;
  margin-right: -15px;
}

.message a{
  color:blue; font-weight:bold;
  font-size: 1rem;
}

@media (max-width: 576px){
  .message a{
    font-size: 12px;
  }
}


.right-corner{
  top: auto !important;
  bottom: auto !important;
  right: 50px !important;
  left: 40px !important;
  position: fixed !important;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/volunteer-opportunity/volunteer-event.component.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;IACV,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,eAAe;AACnB;AACA;;AAEA;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,eAAe;AACnB;AACA;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,UAAU,EAAE,gBAAgB;EAC5B,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;;AAGA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,0BAA0B;AAC5B;AACA,wvEAAwvE","sourcesContent":[".event-info{\r\n  width: 30%;\r\n  float: left;\r\n  margin-right: 1%;\r\n  min-height: 200px;\r\n  margin-top: 50px;\r\n  cursor: pointer;\r\n}\r\n.event-info div{\r\n  font-size: 24px;\r\n}\r\n\r\n@media (max-width: 768px){\r\n  .event-info{\r\n    width: 45%;\r\n    min-height: 140px;\r\n    margin-top: 0px;\r\n    margin-bottom: 15px;\r\n    cursor: pointer;\r\n}\r\n}\r\n\r\n@media (max-width: 576px){\r\n  .event-info{\r\n    width: 100%;\r\n    min-height: 80px;\r\n    margin-top: 0px;\r\n    margin-bottom: 10px;\r\n    cursor: pointer;\r\n}\r\n}\r\n\r\n.mat-card-title{\r\n  margin-left:-16px;\r\n}\r\n\r\n.message{\r\n  margin-bottom: 10px;\r\n  margin-left: -15px;\r\n  margin-right: -15px;\r\n}\r\n\r\n.message a{\r\n  color:blue; font-weight:bold;\r\n  font-size: 1rem;\r\n}\r\n\r\n@media (max-width: 576px){\r\n  .message a{\r\n    font-size: 12px;\r\n  }\r\n}\r\n\r\n\r\n.right-corner{\r\n  top: auto !important;\r\n  bottom: auto !important;\r\n  right: 50px !important;\r\n  left: 40px !important;\r\n  position: fixed !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
